export default "__VITE_ASSET__jM3cizpQ__"